module.exports = __webpack_public_path__ + "static/media/mediteranno.ec15e8b3.jpg";